/** 本次浏览器会话内用户是否关闭了顶部下载条（关闭标签页后重置） */
export const DOWNLOAD_APP_BAR_SESSION_CLOSED_KEY =
  "downloadAppBarSessionClosed";

export function isDownloadAppBarSessionClosed(): boolean {
  try {
    return (
      sessionStorage.getItem(DOWNLOAD_APP_BAR_SESSION_CLOSED_KEY) === "true"
    );
  } catch {
    return false;
  }
}

export function markDownloadAppBarSessionClosed(): void {
  try {
    sessionStorage.setItem(DOWNLOAD_APP_BAR_SESSION_CLOSED_KEY, "true");
  } catch {
    // ignore quota / private mode
  }
}
